










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardBlock extends Vue {

  lightBoxData: any = this.$store.state.FreeCellStore.lightBox

  created() {
    
  }

  closeLightBoxHandler() {
    this.$store.commit('FreeCellStore/SET_LIGHTBOX', null)
  }

}
